export default [
  {
    path: '/cloud-photo',
    name: 'cloud-photo',
    component: () => import('@/pages/my/cloud-photo')
  },
]